// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"590937c0","977":"4420c70f"}[chunkId] + ".chunk.js";
};